import { render } from "./TrailersSlider.vue?vue&type=template&id=4d01b160&scoped=true"
import script from "./TrailersSlider.vue?vue&type=script&lang=js"
export * from "./TrailersSlider.vue?vue&type=script&lang=js"

import "./TrailersSlider.vue?vue&type=style&index=0&id=4d01b160&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d01b160"]])

export default __exports__